module.exports = __webpack_public_path__ + "img/M250.c5ed00c0.jpg";